import { useEffect, useMemo } from 'react';
import s from './MessageItem.module.scss';
import { format } from 'date-fns';
import { useReadSupportMutation } from '../../../../../../redux/apis/supportApi';

export const MessageItem = ({support, message, name, isOnline, isActive, isUnread, setCurrentSupport, unreadLength, handleGetSupports, currentSupport}: any) => {
    
    // ### State
    const r = Math.random()

    const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData')!)
        : null;

    const [ReadSupport] = useReadSupportMutation()

    // ### Effects
    useEffect(()=>{
        if(isActive && unreadLength){
            handleRead()
        }
    },[isActive]);

    // ### Functions

    async function handleRead(){
        await ReadSupport({supportId: support.supportId, user: userData?.id.toString(), isAdmin: true})
        handleGetSupports({currentSupport})
    }
    function handleCurrentChat(support: any){
        setCurrentSupport(support)
        localStorage.setItem("currentSupport", support.supportId)
    }

    const getDarkReadableColor = useMemo(function() {
        let r, g, b, brightness;

        do {
            r = Math.floor(Math.random() * 256);
            g = Math.floor(Math.random() * 256);
            b = Math.floor(Math.random() * 256);

            // Вычисляем яркость по формуле W3C
            brightness = (r * 299 + g * 587 + b * 114) / 1000;
        } while (brightness > 128); // Повторяем, пока цвет не станет достаточно тёмным

        return `rgb(${r}, ${g}, ${b})`;
    }, [name])

    // ### Views

    return(
        <div className={`${s.message} ${isActive ? s.active : ""} ${isUnread ? s.unread : ""}`} onClick={() => handleCurrentChat(support)}>
            <div className={s.online} style={{background: isOnline ? "#04e304" : "red"}}></div>
            <p className={s.avatar} style={{background: support.color || getDarkReadableColor}}>{name[0]}</p>
            <div className={s.column}>
                <div className={s.name_row}>
                    <span className={s.name}>{name}</span>
                    <span className={s.time}>{format(new Date(message.date), "dd.MM HH:mm")}</span>
                </div>
                <div className={s.message_row}>
                    <p className={s.message_text} dangerouslySetInnerHTML={{__html: message?.message}}></p>
                    <span className={s.count}>{unreadLength}</span>
                </div>
            </div>
        </div>
    )
}